var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('link',{attrs:{"rel":"stylesheet","href":"https://wevisu.com/assets/style/style.css","scope":""}}),_c('TopHeader'),_c('router-view',{key:_vm.$route.fullPath,staticStyle:{"min-height":"75vh","margin-top":"0px"}}),_c('Footer'),_c('vue-progress-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }